var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 76.288,
    viewBox: "0 0 160 76.288",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "aeon-picto-blanc-casse\\u0301",
    transform: "translate(-268.473 -169.157)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2917",
    "data-name": "Path 2917",
    d: "M304.792,326.532l-14.531-25.719a.5.5,0,0,0-.477-.265H283.54a.5.5,0,0,0-.477.265l-14.535,25.719c-.132.291-.026.477.291.477H273.9a.5.5,0,0,0,.477-.265L286.554,305.1a.121.121,0,0,1,.212,0l12.164,21.645a.5.5,0,0,0,.477.265h5.083C304.819,327.008,304.924,326.816,304.792,326.532Z",
    transform: "translate(0 -81.696)",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2918",
    "data-name": "Path 2918",
    d: "M415.732,322.152H383.069a.424.424,0,0,0-.42.424v4.02a.378.378,0,0,0,.4.4h32.686a.378.378,0,0,0,.4-.4v-4.047a.378.378,0,0,0-.4-.4Zm0-21.623H383.046a.378.378,0,0,0-.4.4v4.028a.42.42,0,0,0,.42.42h32.663a.378.378,0,0,0,.4-.378v-4.07a.378.378,0,0,0-.4-.4Z",
    transform: "translate(-70.992 -81.685)",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2919",
    "data-name": "Path 2919",
    d: "M416.13,329.406v4.051a.378.378,0,0,1-.4.4H383.07a.42.42,0,0,1-.42-.42v-4a.424.424,0,0,1,.42-.424h32.663a.378.378,0,0,1,.4.4Z",
    transform: "translate(-70.993 -99.393)",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2920",
    "data-name": "Path 2920",
    d: "M525.023,312.959a11.407,11.407,0,0,0-5.639-9.527,23.939,23.939,0,0,0-11.8-2.961h-.794a23.76,23.76,0,0,0-11.835,2.961,11.41,11.41,0,0,0-5.613,9.527,6.735,6.735,0,0,0-.026.821v.053a6.735,6.735,0,0,0,.026.821,11.473,11.473,0,0,0,5.613,9.527,23.725,23.725,0,0,0,11.835,2.912h.794a23.883,23.883,0,0,0,11.8-2.912,11.465,11.465,0,0,0,5.639-9.516,6.723,6.723,0,0,0,.026-.821v-.053A6.762,6.762,0,0,0,525.023,312.959Zm-9.395,7.228a18.192,18.192,0,0,1-8.071,1.929H506.8a18.411,18.411,0,0,1-8.105-1.929,7.012,7.012,0,0,1,0-12.757,18.033,18.033,0,0,1,8.105-1.959h.756a17.818,17.818,0,0,1,8.071,1.959,6.993,6.993,0,0,1,0,12.757Z",
    transform: "translate(-137.314 -81.648)",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2921",
    "data-name": "Path 2921",
    d: "M635.456,300.516h-4.5a.352.352,0,0,0-.4.4V320.1l-23.083-19.406a.7.7,0,0,0-.5-.185h-4.6a.352.352,0,0,0-.378.4v25.674a.352.352,0,0,0,.378.4h4.5a.352.352,0,0,0,.4-.4V307l23.094,19.788a.7.7,0,0,0,.5.185h4.6a.352.352,0,0,0,.378-.4V300.913a.352.352,0,0,0-.39-.4Z",
    transform: "translate(-207.376 -81.671)",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2922",
    "data-name": "Path 2922",
    d: "M533.15,225.607l-11.959-21.18a.514.514,0,0,0-.446-.257h-5.087a.31.31,0,0,0-.272.461l11.914,21.18a.5.5,0,0,0,.477.265h5.083C533.177,226.084,533.283,225.9,533.15,225.607Z",
    transform: "translate(-153.501 -21.771)",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2923",
    "data-name": "Path 2923",
    d: "M409.878,204.18a.514.514,0,0,0-.446.257l-11.963,21.18c-.132.291-.026.477.291.477h5.08a.5.5,0,0,0,.477-.265l11.918-21.18a.31.31,0,0,0-.272-.461Z",
    transform: "translate(-80.172 -21.777)",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2924",
    "data-name": "Path 2924",
    d: "M464.765,204.317h-5.087a.507.507,0,0,1-.477-.265l-17.084-30.345a.125.125,0,0,0-.216,0l-17.1,30.345a.5.5,0,0,1-.477.265H419.25c-.318,0-.424-.185-.291-.477l19.448-34.418a.507.507,0,0,1,.477-.265h6.244a.5.5,0,0,1,.477.265l19.448,34.418C465.188,204.132,465.082,204.317,464.765,204.317Z",
    transform: "translate(-93.534 0)",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2925",
    "data-name": "Path 2925",
    d: "M470.108,234.005l3.525,6.256a.2.2,0,0,0,.34,0l3.521-6.252a.525.525,0,0,0,0-.518l-3.521-6.252a.2.2,0,0,0-.34,0l-3.525,6.256A.515.515,0,0,0,470.108,234.005Z",
    transform: "translate(-125.331 -36.053)",
    fill: "#f4f4f4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.37b86b9a8e4c5fbbb6ce5cf78880873a.svg";
export { ForwardRef as ReactComponent };